import { Option } from '@/components/select'

export default Option
